var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"advantage-module"},[_c('div',{staticClass:"advantage-pic"},[_vm._t("advantage-pic")],2),_vm._v(" "),_c('div',{staticClass:"advantage-title"},[_vm._t("advantage-title")],2),_vm._v(" "),_c('div',{staticClass:"advantage-content"},[_vm._t("advantage-content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cf72237","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/plugins/AdvantageModule.vue
// module id = null
// module chunks = 